import { useRef } from 'react';
import { useContextMenu } from 'react-contexify';

export const MESSAGE_CONTEXT_MENU_ID = 'message-context-menu';

const LONG_PRESS_DURATION = 500;

export type MessageContextMenuItemProps = {
  message: any;
  ownerName: string;
};

export const useMessageContextMenu = () => {
  const { show } = useContextMenu<MessageContextMenuItemProps>({ id: MESSAGE_CONTEXT_MENU_ID });
  const longPressTimer = useRef<ReturnType<typeof setTimeout>>();

  const handleContextMenu = (e: React.MouseEvent, message: any, ownerName: string) => {
    e.preventDefault();
    show({ event: e, props: { message, ownerName } });
  };

  const handleTouchStart = (e: React.TouchEvent, message: any, ownerName: string) => {
    const { clientX, clientY } = e.touches[0];
    longPressTimer.current = setTimeout(() => {
      show({ event: e, props: { message, ownerName }, position: { x: clientX, y: clientY } });
    }, LONG_PRESS_DURATION);
  };

  const clearLongPress = () => {
    if (longPressTimer.current) clearTimeout(longPressTimer.current);
  };

  return {
    handleContextMenu,
    handleTouchStart,
    handleTouchEnd: clearLongPress,
    handleTouchMove: clearLongPress,
  };
};
